/*
 * @Author: RONGWEI PENG
 * @Date: 2022-09-05 14:38:28
 * @LastEditors: zhanghang
 * @LastEditTime: 2022-09-21 17:17:25
 * @FilePath: /dsf-product-dataview/packages/@dsf/cli-dataview/mixins/decorates.js
 */
import dataView from './dataView'
import svg from './svg'
export default {
  mixins: [dataView, svg],
  props: {
    height:{
      type:String,
      default:'100%'
    },
    margin: {
      type: Array,
      default: () => [0, 0, 0, 0],
    },
    padding: {
      type: Array,
      default: () => [10, 0, 0, 0],
    },
    color1: {
      type: String,
      default: "#2783ce"
    },
    color2: {
      type: String,
      default: "#2cf7fe"
    },
    slots: {
      type: Array,
      default() {
        return [
          {
            name: "default",
            controls: [],
          },
        ];
      },
    }
  },
  computed: {
    controlHeight() {
      let { height } = this;
      if (!this.isDesign) {
        return {
          height
        };
      }

    },
    controlStyle() {
      let { margin } = this;
      let style = {
        top: `${margin[0]}px`,
        right: `${margin[1]}px`,
        bottom: `${margin[2]}px`,
        left: `${margin[3]}px`,
      };
      return style;
    },
    controlInnerStyle() {
      let { padding } = this;
      return { padding: padding.join("px ") + "px" };
    },
  },
  mounted() {
    this.resize()
  },
  methods: {
    fade(hex, apl) {
      if (hex && hex.startsWith("#")) {
        return (
          "rgba(" +
          parseInt("0x" + hex.slice(1, 3)) +
          "," +
          parseInt("0x" + hex.slice(3, 5)) +
          "," +
          parseInt("0x" + hex.slice(5, 7)) +
          "," +
          apl / 100 +
          ")"
        );
      } else {
        return hex;
      }
    },
    onResize() {

    },
  }
}